(function ($) {
    "use strict";

    console.log("Variations-Handler geladen - Warte auf Interaktion...");

    // Wir binden an den Body, damit wir auch dynamisch geladene Formen erwischen
    $(document).on('found_variation', function (event, variation) {
        //console.log("EVENT GEFEUERT: Variante gefunden!", variation);

        // 1. Manuelle Specs (Reichweite, Deckel...)
        if (variation.specs_data) {
            $.each(variation.specs_data, function (slug, value) {
                var $row = $('.row-manual[data-slug="' + slug + '"]');
                var $valCell = $row.find('.manual-value');

                if (value && value.trim() !== "" && value !== "-") {
                    $valCell.text(value);
                    $row.show();
                } else {
                    var original = $valCell.data('original');
                    if (original) {
                        $valCell.text(original);
                        $row.show();
                    } else {
                        $row.hide();
                    }
                }
            });
        }

        // 2. Generische Attribute (Gebinde etc.)
        $('.row-generic').each(function () {
            var $row = $(this);
            var taxKey = String($row.data('tax')).toLowerCase();
            var $valCell = $row.find('.value-placeholder');
            var foundVal = "";

            if (variation.attributes) {
                Object.keys(variation.attributes).forEach(function (key) {
                    var cleanKey = key.toLowerCase();
                    if (cleanKey === taxKey || cleanKey === taxKey.replace('attribute_', 'attribute_pa_')) {
                        foundVal = variation.attributes[key];
                    }
                });
            }

            if (foundVal) {
                // Suche den Klarnamen im Dropdown
                var $dropdown = $('select[name="' + taxKey + '"], select[name="' + taxKey.replace('attribute_', 'attribute_pa_') + '"]');
                var niceText = $dropdown.find('option[value="' + foundVal + '"]').text();
                $valCell.text(niceText || foundVal);
                $row.css('display', 'table-row');
            } else {
                $row.hide();
            }
        });

        // 4. Nährwerte & Zutaten
        if (variation.html_nutrition) {
            $('#nutrition-display').fadeOut(100, function() {
                $(this).html(variation.html_nutrition).fadeIn(100);
            });
        }
        if (variation.html_ingredients) {
            $('#ingredients-display').html(variation.html_ingredients);
        }
        if (variation.html_product_data_additional_info) {
            $('#product_data_additional_info-display').html(variation.html_product_data_additional_info);
        }
    });

    // Reset via Page Reload
    $(document).on('click', '.reset_variations', function (e) {
        window.location.reload();
    });

})(jQuery);